<template>
  <div class="animated fadeIn">
    <div class="form-group col-md-6">
      <label>Order</label>
      <multiselect
          v-model="selectedOrder"
          :options="orders"
          label="name"
          track-by="id"
          placeholder="Select order" class="mb-4"/>
    </div>
    <hr>
    <b-button @click="onAdd()" variant="primary">Add Order</b-button>
    <b-button
      @click="section = 'orders'"
      type="reset"
      variant="outline-secondary"
      class="pull-right">Cancel</b-button>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect,
  },
  name: 'add_shipment_order',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      selectedOrder: '',
    };
  },
  created() {
    this.$store.commit('shipment_md/orders/SET_QUERY_COUNT', 999);
    this.$store.dispatch('shipment_md/orders/LOAD_DATA');
  },
  computed: {
    orders() {
      /* eslint-disable */
      const orders = this.$store.getters['shipment_md/orders/orders'];
      const ordersShipmentNull = orders.filter((order) => { return order.shipment === null;});
      ordersShipmentNull.forEach((order) => { order.name = order.number; });

      return ordersShipmentNull;
    },
  },
  watch: {
    section(newSection) {
      const { shipmentId } = this.$route.params;
      this.$router.push(`/shipment_md/shipments/${shipmentId}/${newSection}`);
    },
  },
  methods: {
    onAdd() {
      const { shipmentId } = this.$route.params;
      const { id: orderId } = this.selectedOrder;

      this.$store.dispatch('shipment_md/shipments/ADD_ORDER', {
        order_id: orderId,
      }).then(() => { this.section = 'orders'; });
    },
  },
};
</script>
<style lang="sass">
@import "~vue-multiselect/dist/vue-multiselect.min"
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/detail/AddOrder.vue